import React, { useEffect, useState } from "react";
import "./Footer.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import wa from "../../assets/wablackbkg.png";
import Logo from "../../assets/VPEX LOGO V V.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [alignItems, setAlignItems] = useState("start");

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setAlignItems(window.innerWidth <= 440 ? "center" : "start");
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <footer className="container-f pb-5 pt-5" id="contact">
      <Container fluid className={`text-center container ${width <= 1280 ? "w-75" : "w-50"}`}>
        <Row className="mt-5 align-items-center justify-content-center grid-p">
          <Col className={`d-flex flex-column align-items-${alignItems} mb-auto info-f ${width >= 1441 ? "margin-l" : "ms-0"}`}>
            <div className="d-flex flex-row">
              <FontAwesomeIcon icon={faLocationDot} className="text-light me-3 mb-3 fs-3" />
              <p className="text-light address">Uruguay</p>
            </div>
            <div className="d-flex flex-row align-items-center socialnetwork brand-p">
              <a href="https://www.instagram.com/vpexuy" target="_blank" rel="noreferrer" aria-label="Instagram de VPEX">
                <FontAwesomeIcon icon={faInstagram} className="text-light fs-3 me-3 mb-2" />
              </a>
              <p className="text-light address mt-1">@vpexuy</p>
            </div>
            <div className="d-flex flex-row align-items-center socialnetwork linkedin">
              <a href="https://www.linkedin.com/company/vpex-infra-dev/about/" target="_blank" rel="noreferrer" aria-label="LinkedIn de VPEX">
                <FontAwesomeIcon icon={faLinkedin} className="text-light me-3 mb-3 fs-3 mt-1 icon-link" />
              </a>
              <p className="text-light address linkedin-txt">VPEX - Infrastructure & Development</p>
            </div>
            <div className="d-flex align-items-center tel mt-1">
              <a className="btn-wa img-fluid" href="https://wa.me/59899447449" target="_blank" rel="noreferrer" aria-label="WhatsApp de VPEX">
                <img src={wa} alt="WhatsApp" className="img-wa" />
              </a>
              <p className="text-light ms-1 telephone">Teléfono: +598 99 447 449</p>
            </div>
            <div className="d-flex align-items-center mt-2">
              <FontAwesomeIcon icon={faEnvelope} className="text-light me-3" />
              <a className="text-light" href="mailto:valvarez@vpex.com.uy">valvarez@vpex.com.uy</a>
            </div>
          </Col>
          <Col className="d-flex flex-column align-items-center mb-auto info-f">
            <img src={Logo} alt="Logo de VPEX" className="img-fluid logo-f" />
            <p className="text-light mt-3 mb-1"><strong>Administrador:</strong> Valentin Alvarez</p>
            <p className="text-light mb-1"><strong>CI:</strong> 52879776</p>
          </Col>
        </Row>
        <hr className="separator" />
        <nav className="footer-policy-links" aria-label="Ayuda e información legal">
          <Link to="/faq">Ayuda, políticas e información legal</Link>
        </nav>
        <p className="text-light legal mt-3">© 2026 VPEX. Todos los derechos reservados.</p>
      </Container>
    </footer>
  );
};

export default Footer;
